import jp2 from './ravi.jp2';
import jpg from './ravi.jpg';
import webp from './ravi.webp';

export default [jp2, webp, jpg];
